import script from "./locationSummary.vue?vue&type=script&lang=ts&setup=true"
export * from "./locationSummary.vue?vue&type=script&lang=ts&setup=true"

import "./locationSummary.vue?vue&type=style&index=0&id=83aa4ea4&lang=scss&scoped=true"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83aa4ea4"]])

export default __exports__